// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3PpB6","paramInput":"JobSimulator_paramInput__36rmB","input":"JobSimulator_input__181KZ"};